import { Stack, SxProps, Typography } from "@mui/material";

const EmptyContent = ({ message, sx }: { message?: string; sx?: SxProps }) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      width: "100%",
      height: "220px",
      bgcolor: "shades.neutral.50",
      borderRadius: "8px",
      ...sx,
    }}
  >
    <Typography variant="bodyPrimaryMed" sx={{ color: "shades.neutral.500" }}>
      {message ? message : "Not enough data"}
    </Typography>
  </Stack>
);

export default EmptyContent;
